import React from 'react';

export interface SampleDataBannerProps {
  show: boolean;
  onDeleteSampleData: () => void;
}

export const SampleDataBanner: React.FC<SampleDataBannerProps> = ({
  show,
  onDeleteSampleData
}) => {
  if (!show) return null;

  return (
    <div className="bg-gradient-to-r from-indigo-600 to-indigo-700 text-white px-6 py-3 flex items-center justify-between shadow-md shrink-0 border-b border-indigo-500/20 z-[10] print:hidden">
      <div className="flex items-center gap-3">
        <span className="text-lg">💡</span>
        <p className="text-xs font-medium">
          Sie sehen ein <span className="font-bold underline">Beispielprojekt</span> mit Probedaten, um alle Funktionen (Gantt, Kanban, Kalender, etc.) kennenzulernen.
        </p>
      </div>
      <button 
        onClick={onDeleteSampleData}
        className="bg-white/15 hover:bg-white/25 active:scale-95 text-white text-xs font-bold px-4 py-1.5 rounded-xl border border-white/10 transition-all flex items-center gap-1.5 shadow-sm"
      >
        <span>Beispieldaten löschen</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 6h18m-2 0v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
        </svg>
      </button>
    </div>
  );
};

export default SampleDataBanner;
